import styled from 'styled-components';

export const Box = styled.div`
	width: 64px;
	height: 64px;
	background: linear-gradient(45deg, ${({ theme }) => theme.gray[200]} 25%, transparent 25%),
		linear-gradient(-45deg, ${({ theme }) => theme.gray[200]} 25%, transparent 25%),
		linear-gradient(45deg, transparent 75%, ${({ theme }) => theme.gray[200]} 75%),
		linear-gradient(-45deg, transparent 75%, ${({ theme }) => theme.gray[200]} 75%);
	background-size: 8px 8px;
	background-position: 0 0, 0 4px, 4px -4px, -4px 0px;
	border-radius: 8px;
	position: relative;
	overflow: hidden;
`;

export const Overlay = styled.div<{ $opacity: number }>`
	width: 100%;
	height: 100%;
	background-color: ${({ theme }) => theme.gray[1000]};
	opacity: ${({ $opacity }) => $opacity};
`;
